import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';

import { MedicionyfacturacionRoutingModule } from './medicionyfacturacion-routing.module';
import { ReportesComponent } from './reportes/reportes.component';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentesModule } from '../componentes/componentes.module';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';


@NgModule({
  declarations: [
  ReportesComponent,
  //VisorComponent,
],
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    ReactiveFormsModule,
    MultiSelectModule,
    DialogModule,
    MedicionyfacturacionRoutingModule,
    ComponentesModule,
    ProgressBarModule
  ]
})
export class MedicionyfacturacionModule { 

}
